<template>
    <form autocomplete="off">
        <div class="row gy-3">
            <div class="col-12">
                <label>Area of Specialization <span class="text-danger">*</span></label>
                <input type="text"
                    class="form-control"
                    placeholder="Enter area of specialization"
                    v-model="form.specialization"
                    :class="{ 'is-invalid': v$.form.specialization.$error }">
                <div class="invalid-feedback"
                    v-for="(item,index) in v$.form.specialization.$errors"
                    :key="index">
                    {{ item.$message }}
                </div>
            </div>
            <div class="col-12">
                <label>Research Interests</label>
                <textarea
                    rows="3"
                    class="form-control"
                    placeholder="Separate multiple interests with commas"
                    v-model="form.research_interests"></textarea>
            </div>
            <div class="col-lg-6">
                <label>ORCID</label>
                <input type="text"
                    class="form-control"
                    placeholder="0000-0000-0000-0000"
                    v-model="form.orcid">
            </div>
            <div class="col-lg-6">
                <label>Google Scholar Profile</label>
                <input type="url"
                    class="form-control"
                    placeholder="https://scholar.google.com/..."
                    v-model="form.google_scholar">
            </div>
            <div class="col-lg-6">
                <label>Scopus Author ID</label>
                <input type="text"
                    class="form-control"
                    placeholder="Enter scopus author ID"
                    v-model="form.scopus_author_id">
            </div>
            <div class="col-lg-6">
                <label>Web of Science ID</label>
                <input type="text"
                    class="form-control"
                    placeholder="Enter web of science ID"
                    v-model="form.web_of_science_id">
            </div>
            <div class="col-12">
                <label>ResearchGate Profile</label>
                <input type="url"
                    class="form-control"
                    placeholder="https://www.researchgate.net/profile/..."
                    v-model="form.research_gate">
            </div>
            <div class="col-lg-6">
                <label>Total Publications</label>
                <CommonIncrementInput
                    v-model="form.total_publications"
                    :min="1"
                    :max="100"
                />
            </div>

            <div class="col-lg-6">
                <label>Total Citations</label>
                <CommonIncrementInput
                    v-model="form.total_citations"
                    :min="1"
                    :max="100"
                />
            </div>

            <div class="col-lg-6">
                <label>h-index</label>
                <CommonIncrementInput
                    v-model="form.h_index"
                    :min="1"
                    :max="100"
                />
            </div>

            <div class="col-lg-6">
                <label>i10-index</label>
                <CommonIncrementInput
                    v-model="form.i10_index"
                    :min="1"
                    :max="100"
                />
            </div>

            <div class="col-lg-4">
                <label>Research Grants</label>
                <CommonIncrementInput
                    v-model="form.research_grants"
                    :min="1"
                    :max="100"
                />
            </div>

            <div class="col-lg-4">
                <label>Awards</label>
                <CommonIncrementInput
                    v-model="form.awards"
                    :min="1"
                    :max="100"
                />
            </div>

            <div class="col-lg-4">
                <label>Patents</label>
                <CommonIncrementInput
                    v-model="form.patents"
                    :min="1"
                    :max="100"
                />
            </div>
            <div class="col-12">
                <div class="d-flex justify-content-end mt-3">
                    <b-button
                        variant="primary"
                        type="button"
                        @click.prevent="editMode ? update() : create()">
                        {{ editMode ? 'Update' : 'Submit' }}
                    </b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers, numeric } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    props:{
        editItem:{
            type:Object,
            default:null
        },
        editMode:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            form:{
                specialization:"",
                research_interests:"",
                orcid:"",
                google_scholar:"",
                scopus_author_id:"",
                web_of_science_id:"",
                research_gate:"",

                total_publications:0,
                total_citations:0,
                h_index:0,
                i10_index:0,
                research_grants:0,
                awards:0,
                patents:0
            }
        }
    },
    validations(){
        return{
            form:{
                specialization:{
                    required: helpers.withMessage("Area of specialization is required", required)
                },
                total_publications:{
                    numeric: helpers.withMessage("Total publications must be a number", numeric)
                },
                total_citations:{
                    numeric: helpers.withMessage("Total citations must be a number", numeric)
                },
                h_index:{
                    numeric: helpers.withMessage("h-index must be a number", numeric)
                },
                i10_index:{
                    numeric: helpers.withMessage("i10-index must be a number", numeric)
                },
                research_grants:{
                    numeric: helpers.withMessage("Research grants must be a number", numeric)
                },
                awards:{
                    numeric: helpers.withMessage("Awards must be a number", numeric)
                },
                patents:{
                    numeric: helpers.withMessage("Patents must be a number", numeric)
                }
            }
        }
    },
    methods:{
        create(){
            this.v$.$validate().then(result=>{
                if(!result){
                    this.alertError(this.v$.$errors[0].$message);
                    return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post('/research-profiles/create', this.form)
                .then(response=>{
                    this.$store.dispatch("changeLoaderValue", false);
                    if(response.data.success){
                        this.$emit("addedItem", response.data.data);
                        this.resetForm();
                    }
                });
            });
        },
        update(){
            this.v$.$validate().then(result=>{
                if(!result){
                    this.alertError(this.v$.$errors[0].$message);
                    return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post(`/research-profiles/${this.editItem.id}/update`, this.form)
                .then(response=>{
                    this.$store.dispatch("changeLoaderValue", false);
                    if(response.data.success){
                        this.$emit("updatedItem", response.data.data);
                        this.resetForm();
                    }
                });
            });
        },
        resetForm(){
            this.v$.$reset();
            this.$emit("closeMe");
        }
    },
    created(){
        if(this.editMode){
            this.form = this.$filters.patchUpdatables(this.form, this.editItem);
        }
    }
}
</script>